/** Anonymous TRITAL corporate hiring-funnel telemetry. No PII or resume metadata. */
const ALLOWED=new Set(["page_view","verified_job_detail_view","hot_jobs_application_started","hot_jobs_application_accepted","hot_job_detail_view","generate_lead","new_grad_interest_submitted","staffer_rn_market_view"]);
export function trackRecruitingEvent(name,details={}){
 if(!ALLOWED.has(name))return;
 if(typeof window==="undefined"||!/^(www\.)?tritalcare\.com$/i.test(window.location.hostname))return;
 if(typeof window.gtag!=="function")return;
 const safe={};
 for(const k of ["job_slug","job_category","job_state","lead_type","market_state","market_city","source_type"]){
  const v=details[k];
  if(typeof v==="string"&&v.length>0&&v.length<=100&&/^[a-zA-Z0-9 _\/-]+$/.test(v))safe[k]=v;
 }
 if(name==="page_view"){safe.page_path=window.location.pathname;safe.page_location="https://www.tritalcare.com"+window.location.pathname;}
 window.gtag("event",name,safe);
}
